import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import { queryClient } from '@/lib/query-client';
import { AppearanceMotionProvider } from '@/features/appearance/AppearanceMotionProvider';
import { AppThemeProvider } from '@/features/theme/AppThemeProvider';
import { applyAppearanceMotion } from '@/features/appearance/applyAppearanceMotion';
import { useAppearanceSettingsStore } from '@/features/appearance/appearance-settings.store';

interface ProvidersProps {
  children: ReactNode;
}

/** Apply saved motion prefs before first paint (avoids flash of motion). */
if (typeof document !== 'undefined') {
  applyAppearanceMotion({
    animationsEnabled: useAppearanceSettingsStore.getState().animationsEnabled,
  });
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppearanceMotionProvider>
        <AppThemeProvider>{children}</AppThemeProvider>
      </AppearanceMotionProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
